//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Tooling.js";
import "../no/Builder.js";
import "../no/SelectNXObject.js";
import "../no/SelectBody.js";
import "../GeometricUtilities/GeometricUtilities.SurfaceRangeBuilder.js";
import "../no/GeometricUtilities.js";
import "../no/SelectObject.js";
let d=[[[0,"IsEnlarge",1,0],[0,"ReverseTrimDirection",1,0],[1,"SplitObject",0,"SelectNXObject",0],[0,"SplitPlane",1,"Plane",0],[1,"SplitTarget",0,"SelectBody",0],[1,"SurfaceRange",0,"GeometricUtilities.SurfaceRangeBuilder",0],[0,"ToolOption",1,0],[0,"Type",1,0]],[[["enlargedSurfaceData"],"SetEnlargedSurfaceData",{},1,0]],[]];
SPLM.Tooling.SplitSolidBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Tooling.SplitSolidBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Tooling.SplitSolidBuilder.OperationType = Object.freeze({
    "Split" : "Split", "Trim" : "Trim"});

SPLM.Tooling.SplitSolidBuilder.ToolObjectOption = Object.freeze({
    "ExistingObject" : "ExistingObject", "NewPlane" : "NewPlane"});

export default SPLM;